import Global from "@/components/Global";
import { webTypeApiUrl } from "@/constants/webTypeApiUrl";

export const AttachFileHandler = {
  Hello: function () {
    alert("AttachFileHander.js");
  },

  ///依查詢文字取得相關文件
  GetContentFilter: function (searchNodeText, brandList) {    
    if ((brandList.length == 0))
    {            
      brandList = ["TutorABC", "tutorJr"];
    }
    var contentlist = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/Chat/GetContentFilter",
      type: "post",
      async: false,
      data: {
        brand: brandList,
        staffId: Global.current_staffid,
        searchText: searchNodeText
      },
      dataType: "json",
      success: function (data) {
        contentlist = data;
      },
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
    return contentlist;
  },
  //傳送附件訊息
  SendContentMessage: function (contentId) {
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/Chat/SendContentMessage",
      type: "post",
      async: false,
      data: {
        roomId: Global.current_roomid,
        contentId: contentId,
        staffId: Global.current_staffid
      },
      dataType: "json",
      success: function (data) {
        if (!data.Success) {
          alert(data.DisplayMessage);
        }
      },
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
  },

  //取得分類數狀圖
  GetContentNodeTree: function (brand) {
    
    if ((brand.length == 0))
    {            
      brand = ["TutorABC", "tutorJr"];
    }
     
    var tree = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/Chat/GetContentNodeTree",
      type: "post",
      async: false,
      data: {
        staffId: Global.current_staffid,
        brand: brand
      },
      dataType: "json",
      success: function (data) {
        tree = data;
      },
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
    return tree;
  },
  //取得節點文件資料
  GetContentByNodeId: function (nodeId, brand) {

    if ((brand.length == 0))
    {            
      brand = ["TutorABC", "tutorJr"];
    }

    var tableData = [];
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/Chat/GetContentByNodeId",
      type: "post",
      async: false,
      data: {
        nodeId: nodeId,
        staffId: Global.current_staffid,
        brand: brand,
        roomId: Global.current_roomid
      },
      dataType: "json",
      success: function (data) {
        tableData = data;
      },
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
    return tableData;
  }
};



// WEBPACK FOOTER //
// ./src/handler/AttachFileHandler.js